import React from 'react';
import { useNavigate } from 'react-router-dom';
import useIsMobile from "../../../hooks/useIsMobile";
import PaymentDesktopHeader from "./PaymentDesktopHeader";
import StepNavigationHeader from "../ItineraryHeader";


type Props = {
  navigateHandler?: () => void
}
function PaymentHeaderNavigation({ navigateHandler }: Props) {
  const { isMobile } = useIsMobile();
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (navigateHandler) {
      navigateHandler();
    } else {
      navigate(-1);
    }
  };

  return (
      isMobile ? (
          <StepNavigationHeader name="Make payment" stepText="4 of 4" navigateHandler={handleNavigate} />
      ) : (
          <PaymentDesktopHeader navigateHandler={handleNavigate} />
      )
  )
}

PaymentHeaderNavigation.defaultProps = {
  name: undefined,
  navigateHandler: undefined,
};

export default PaymentHeaderNavigation;
